var _path, _path2, _g, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 154,
    viewBox: "0 0 170 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2676_18248)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2676_18248",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 171,
    height: 154
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.592 0.00292969H-0.0078125V153.603H169.592V0.00292969Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2676_18248)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2676_18248",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -47,
    y: -23,
    width: 738,
    height: 826
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-46.0234 -22.8076H690.969V802.631H-46.0234V-22.8076Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2676_18248)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7422 76.4016L103.463 30.1543L23.7422 76.4016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7422 76.4016L103.463 30.1543",
    stroke: "#E5E5E5",
    strokeWidth: 22.0833,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7109 106.732L122.431 60.4844L42.7109 106.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7109 106.732L122.431 60.4844",
    stroke: "#E5E5E5",
    strokeWidth: 22.0833,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.844 48.8569L149.057 45.2051L142.844 48.8569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.844 48.8569L149.057 45.2051",
    stroke: "#E5E5E5",
    strokeWidth: 22.0833,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.8359 131.689L131.381 95.9834L70.8359 131.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8359 131.689L131.381 95.9834",
    stroke: "#E5E5E5",
    strokeWidth: 22.0833,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.284 99.1585C147.251 99.2621 147.955 100.137 147.855 101.11C147.755 102.084 146.889 102.79 145.922 102.687C144.955 102.583 144.251 101.708 144.35 100.735C144.45 99.7612 145.316 99.0549 146.284 99.1585Z",
    stroke: "#00C83C",
    strokeWidth: 1.02805
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4206 136.026C45.0109 136.196 46.1688 137.634 46.0047 139.235C45.8406 140.836 44.4161 141.998 42.8258 141.827C41.2355 141.657 40.0776 140.219 40.2417 138.618C40.4058 137.017 41.8303 135.855 43.4206 136.026Z",
    stroke: "#00C83C",
    strokeWidth: 1.69056
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5221 15.592C85.1124 15.7625 86.2704 17.2007 86.1063 18.8016C85.9421 20.4026 84.5177 21.564 82.9274 21.3936C81.3371 21.2232 80.1791 19.7849 80.3433 18.184C80.5074 16.583 81.9318 15.4216 83.5221 15.592Z",
    stroke: "#00C83C",
    strokeWidth: 1.69056
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5615 53.7637C17.2939 53.7637 17.8885 54.3641 17.8885 55.1036C17.8885 55.8431 17.2939 56.4435 16.5615 56.4435C15.829 56.4435 15.2344 55.8431 15.2344 55.1036C15.2344 54.3641 15.829 53.7637 16.5615 53.7637Z",
    stroke: "#00C83C",
    strokeWidth: 1.23573
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.632 141.141C120.364 141.141 120.959 141.741 120.959 142.481C120.959 143.22 120.364 143.82 119.632 143.82C118.899 143.82 118.305 143.22 118.305 142.481C118.305 141.741 118.899 141.141 119.632 141.141Z",
    stroke: "#4D5762",
    strokeWidth: 1.23573
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.086 15.2207L135.968 9.91679",
    stroke: "#4D5762",
    strokeWidth: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.992 12.1514L138.245 13.0418",
    stroke: "#4D5762",
    strokeWidth: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2812 103.016L22.9383 97.6778",
    stroke: "#4D5762",
    strokeWidth: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0625 100.035L25.348 100.698",
    stroke: "#4D5762",
    strokeWidth: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.055 126.264L133.341 120.892",
    stroke: "#4D5762",
    strokeWidth: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.617 123.449L135.936 123.738",
    stroke: "#4D5762",
    strokeWidth: 0.72
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8142 38.1416C105.951 38.1416 123.113 55.4692 123.113 76.8106C123.113 98.152 105.951 115.48 84.8142 115.48C63.6772 115.48 46.5156 98.152 46.5156 76.8106C46.5156 55.4692 63.6772 38.1416 84.8142 38.1416Z",
    fill: "#404040"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7935 41.7988C103.931 41.7988 119.47 57.4876 119.47 76.8105C119.47 96.1335 103.931 111.822 84.7935 111.822C65.6556 111.822 50.1172 96.1335 50.1172 76.8105C50.1172 57.4876 65.6556 41.7988 84.7935 41.7988Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1406 78.096L78.5155 87.3465L100.461 65.1885",
    stroke: "#07B83C",
    strokeWidth: 4.32
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2676_18248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169.6,
    height: 153.6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/successTick.08c1b410ca26682b159f53853fc1336e.svg";
export { ForwardRef as ReactComponent };